<template>
  <div class="VIPInformation">
  <L1 :titlegap="'12px'">
    <template slot="slot_title">
      <Select :style="{width: '135px'}" :width="'135px'" :defaultValue="role" @input="role=$event">
        <option :value="null">類型</option>
        <option v-for="(r, i) in Object.keys(rolesmap)" :key="`role-${i}`" :value="r">{{rolesmap[r]}}</option>
      </Select>
      <Select :style="{width: '145px'}" :defaultValue="level" @input="level=$event">
        <option :value="null">會員等級</option>
        <option :value="vn" v-for="vn in Object.keys(vipName)" :key="`vip-${vn}`"><span class="vip" :class="`vip${vn}`"></span>{{vipName[vn]}}</option>
      </Select>
      <Select :style="{width: '165px'}" :defaultValue="blank" @input="blank=$event">
        <option :value="null">全部(黑名單)</option>
        <option :value="false">非黑名單</option>
        <option :value="true">黑名單</option>
      </Select>
      <Select :style="{width: '135px'}" :defaultValue="mobileVerified" @input="mobileVerified=$event">
        <option :value="null">簡訊驗證</option>
        <option :value="true">已驗證</option>
        <option :value="false">未驗證</option>
      </Select>
      <!-- <Select :style="{width: '140px'}" class="small" :defaultValue="age" @input="age=$event">
        <option :value="null">年齡</option>
        <option :value="8">0 ~ 12</option>
        <option :value="1">13 ~ 18</option>
        <option :value="2">19 ~ 24</option>
        <option :value="3">25 ~ 34</option>
        <option :value="4">35 ~ 44</option>
        <option :value="5">45 ~ 54</option>
        <option :value="6">55 ~ 64</option>
        <option :value="7">65 以上 </option>
      </Select>
      <Select :style="{width: '175px'}" :defaultValue="country" @input="country=$event">
        <option :value="null">居住縣市</option>
        <option v-for="(country, i) in countries" :key="`country-${i}`" :value="country">{{country}}</option>
      </Select> -->
      <Select :style="{width: '135px'}" :defaultValue="tag" @input="tag=$event">
        <option :value="null">全部標籤</option>
        <option v-for="(tg, i) in tags" :key="`country-${i}`" :value="tg.options">{{tg.options}}({{tg.sum}})</option>
      </Select>
      <input type="text" class="search" v-model="searchText" placeholder="搜尋">
      <div :style="{marginInline: 'auto'}"></div>
      <div class="totalCount">共 {{count}} 筆</div>
      <page-50 :defaultValue="page" @input="page=$event" :max="max"/>
      <a class="roundbtn" :href="`${VUE_APP_BASE_URL}/webapi/users/excel?${params}`" target="__blank"><div></div>匯出</a>
      <!-- <span :style="{marginLeft:'auto'}">
        <button class="addTeam" @click="page=page-1" :disabled="page<=1">上一頁<iconPlay/></button>
        <div class="pageNum">{{page}}</div>
        <button class="importData" @click="page=page+1" :disabled="(count/limit)<=page"><iconPlay :style="{transform: 'rotate(180deg)'}"/>下一頁</button>
      </span> -->
    </template>
    <Table :rows="users">
      <template slot="slot_head">
        <th :style="{textAlign: 'start', width: '10em'}">類型</th>
        <th :style="{textAlign: 'start', width: '4em'}">來自</th>
        <th :style="{width: '60px'}"></th>
        <th :style="{textAlign: 'start', width: '10em'}">顯示名稱</th>
        <th :style="{width: '60px'}"></th>
        <th :style="{textAlign: 'start', width: '14em'}">使用者暱稱</th>
        <th :style="{textAlign: 'start', width: '50px', textAlign: 'center', padding: 0}">標籤</th>
        <th :style="{width: '4em'}">性別</th>
        <th :style="{textAlign: 'start', width: '7em'}">生日</th>
        <th :style="{textAlign: 'start', width: '6em'}">居住縣市</th>
        <th :style="{textAlign: 'start', width: '8em'}">消費</th>
        <th :style="{textAlign: 'start', width: 'inherit'}">註記</th>
        <th :style="{textAlign: 'start', width: '10em'}">註冊時間</th>
      </template>
      <tr slot-scope="{item}" :style="{height: '64px', border: 'none'}"  @click="itemSelect=itemSelect&&itemSelect._id===item._id?null:item" :class="itemSelect&&itemSelect._id===item._id?'selected':''">
        <td :style="{textAlign: 'start', whiteSpace: 'nowrap'}">
          <div class="flex" :style="{gap: '5px', width: 'fit-content', alignItems:'center'}">
          {{rolesmap[item.role]}}
          <div v-if="item.level" class="vip" :style="{marginLeft: 'auto', backgroundImage: `url(.${vipImg[item.level]})`}" :title="vipName[item.level]"></div>
        </div>
        </td>
        <td :style="{textAlign: 'start', whiteSpace: 'nowrap'}">{{item.provider.replace('@', '').toUpperCase()}}</td>
        <td :class="item.blank?'hover':''">
          <svg class="blank" v-if="item.blank" width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_2766_1183)">
            <path d="M15.0013 30.0026C23.2863 30.0026 30.0026 23.2863 30.0026 15.0013C30.0026 6.7163 23.2863 0 15.0013 0C6.7163 0 0 6.7163 0 15.0013C0 23.2863 6.7163 30.0026 15.0013 30.0026Z" fill="black"/>
            <path d="M8.26491 19.9403C9.33771 22.8284 8.37501 24.8204 7.03337 25.4246C6.11419 25.8727 4.94922 25.5373 4.65989 24.5285C4.4141 23.5658 4.9953 22.8719 5.82231 22.5365C6.78501 22.1781 7.92694 21.1923 7.99607 19.9403H8.26491ZM13.3012 18.9776V16.4249H6.98984L6.81061 15.7976H13.3037V13.2679H10.1673V13.8491C10.1673 14.141 8.7565 14.8323 7.45839 14.8323H6.98984V4.64714L10.3926 5.94525H19.5716L20.9823 4.3783L23.9165 6.59303C23.7808 6.77225 23.512 6.99757 23.0434 7.08718V13.4472C23.0204 13.5573 22.0782 13.9157 21.1616 14.0745C21.7658 14.5686 22.772 15.4187 23.4685 16.0664C23.4019 16.3122 23.1561 16.4249 22.8412 16.4249H16.4377V18.9776H20.8466L22.4827 16.7398C22.4827 16.7398 24.3185 18.2402 25.3708 19.2464C25.3043 19.4922 25.0585 19.6049 24.723 19.6049H4.86216L4.68294 18.9776H13.3012ZM13.3012 12.6406V6.57254H10.1673V7.62486L10.3235 7.55829C15.3392 9.32751 12.6073 12.9991 10.7485 11.0942C10.8151 9.97529 10.5027 8.74375 10.1673 7.82457V12.6381H13.3012V12.6406ZM10.9738 20.0299C16.6169 22.7158 13.3703 27.1273 11.1761 24.6642C11.3553 23.1203 11.1095 21.4407 10.7485 20.1195L10.9738 20.0299ZM14.8707 20.0965C21.9015 21.5969 19.3949 26.925 16.6834 24.8434C16.4146 23.2304 15.5185 21.4637 14.6659 20.2091L14.8707 20.0965ZM16.4377 6.5751V12.6432H19.7969V9.12524C19.103 9.81911 17.8945 10.8484 16.8191 11.6319L16.6194 11.5422C16.9548 10.2672 17.3133 8.33921 17.426 7.39955L19.7994 8.24959V6.56998H16.4377V6.5751ZM16.4377 15.7976H19.1004L20.3089 14.141H19.7943V13.2679H16.4377V15.7976ZM19.3923 20.1426C27.7213 20.6342 25.8855 26.9045 22.7951 25.1353C22.2574 23.343 20.734 21.4202 19.2336 20.2988L19.3923 20.1426Z" fill="white"/>
            </g>
            <defs>
            <clipPath id="clip0_2766_1183">
            <rect width="30" height="30" fill="white"/>
            </clipPath>
            </defs>
          </svg>
          <svg class="blank" v-else-if="item.mobileVerified" xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
            <path d="M13.1382 18.4792C12.5477 18.4808 11.9759 18.2722 11.525 17.8907L8.19619 15.0706C7.74892 14.6616 7.70503 13.9718 8.09684 13.5093C8.48866 13.0469 9.17613 12.9771 9.65293 13.3513L12.9814 16.1714C13.0843 16.258 13.2375 16.2464 13.3261 16.1455L19.0697 9.56325C19.485 9.12076 20.1761 9.08645 20.6329 9.48545C21.0902 9.88444 21.1496 10.5735 20.7678 11.0451L15.0254 17.627C14.5494 18.1704 13.8611 18.4816 13.1382 18.4792ZM13.9733 27.9618C6.25587 27.9618 0 21.7059 0 13.9885C0 6.27113 6.25587 0.0152588 13.9733 0.0152588C21.6907 0.0152588 27.9465 6.27113 27.9465 13.9885C27.9374 21.7019 21.6867 27.953 13.9733 27.9618ZM13.9733 2.26919C9.23318 2.26919 4.95993 5.12441 3.14609 9.5038C1.33225 13.8832 2.33453 18.9237 5.6865 22.2757C9.03808 25.6273 14.079 26.6299 18.4584 24.8161C22.8378 23.0019 25.693 18.7286 25.693 13.9885C25.6854 7.51919 20.4426 2.27677 13.9733 2.26919Z" fill="#7FA451"/>
          </svg>
        </td>
        <td :style="{textAlign: 'start'}">{{item.lineName}}<span v-if="item.pause">(停用)</span></td>
        <td :style="{paddingRight: 0, textAlign: 'end'}" :class="item.internalRemark?'hover':''">
          <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg" v-if="item.internalRemark">
            <mask id="mask0_1004_5735" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="0" width="25" height="25">
            <path d="M24.9666 0H0V25H24.9666V0Z" fill="white"/>
            </mask>
            <g mask="url(#mask0_1004_5735)">
            <path d="M11.1445 12.4846C11.1445 13.2232 11.7432 13.8219 12.4819 13.8219C13.2206 13.8219 13.8192 13.2232 13.8192 12.4846C13.8192 11.7459 13.2206 11.1472 12.4819 11.1472C11.7436 11.1472 11.1445 11.7459 11.1445 12.4846ZM16.7168 12.4846C16.7168 13.2232 17.3155 13.8219 18.0542 13.8219C18.7928 13.8219 19.3915 13.2232 19.3915 12.4846C19.3915 11.7459 18.7928 11.1472 18.0542 11.1472C17.3158 11.1472 16.7168 11.7459 16.7168 12.4846ZM5.57227 12.4846C5.57227 13.2232 6.17094 13.8219 6.90961 13.8219C7.64829 13.8219 8.24696 13.2232 8.24696 12.4846C8.24696 11.7459 7.64829 11.1472 6.90961 11.1472C6.17128 11.1472 5.57227 11.7459 5.57227 12.4846Z" fill="#FF7373"/>
            </g>
            <mask id="mask1_1004_5735" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="0" width="25" height="25">
            <path d="M24.9666 0H0V25H24.9666V0Z" fill="white"/>
            </mask>
            <g mask="url(#mask1_1004_5735)">
            <path d="M23.9947 7.64784C23.365 6.15169 22.4623 4.80877 21.3116 3.65531C20.161 2.50464 18.8181 1.59914 17.3191 0.972261C15.7867 0.328663 14.1596 0.00268555 12.4824 0.00268555H12.4267C10.7383 0.011044 9.1028 0.34538 7.56485 1.00291C6.07984 1.63815 4.74807 2.54086 3.60854 3.69153C2.46901 4.8422 1.57466 6.17955 0.956138 7.67013C0.314979 9.21365 -0.00786467 10.8547 0.00014547 12.5431C0.00850388 14.4767 0.471003 16.3963 1.33749 18.1126V22.3475C1.33749 23.0552 1.91143 23.6291 2.61911 23.6291H6.85683C8.57309 24.4956 10.4927 24.9581 12.4263 24.9665H12.4848C14.1537 24.9665 15.7725 24.6433 17.2965 24.0108C18.7871 23.3895 20.1272 22.4979 21.2751 21.3584C22.4258 20.2189 23.3312 18.8871 23.9637 17.4021C24.6212 15.8642 24.9556 14.2287 24.9639 12.5403C24.9723 10.8435 24.6439 9.19694 23.9947 7.64784ZM19.7848 19.8511C17.8318 21.7847 15.2407 22.849 12.4824 22.849H12.435C10.755 22.8406 9.08608 22.4227 7.61222 21.637L7.37818 21.5117H3.45495V17.5888L3.32958 17.3547C2.54389 15.8809 2.12597 14.212 2.11796 12.5319C2.10681 9.75416 3.16833 7.14634 5.11584 5.18211C7.06056 3.21789 9.66003 2.13129 12.4378 2.12015H12.4852C13.8782 2.12015 15.2295 2.3904 16.5028 2.92534C17.7454 3.44635 18.8598 4.19582 19.8183 5.15425C20.7739 6.1099 21.5262 7.22714 22.0472 8.46975C22.5877 9.75695 22.858 11.1222 22.8524 12.5319C22.8353 15.3069 21.7463 17.9064 19.7848 19.8511Z" fill="#FF7373"/>
            </g>
          </svg>
          <div class="hoverCube">{{item.internalRemark}}</div>
        </td>
        <td :style="{textAlign: 'start'}">{{item.name}}</td>
        <td :style="{padding: '0', textAlign: 'center'}" :class="item.tags?'hover':''">
          <svg width="24" height="30" viewBox="0 0 24 30" fill="none" xmlns="http://www.w3.org/2000/svg" v-if="item.tags&&item.tags.length>0" :style="{margin: 'auto'}">
            <mask id="mask0_908_5111" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="30">
            <path d="M23.5666 0H0.00439453V30H23.5666V0Z" fill="white"/>
            </mask>
            <g mask="url(#mask0_908_5111)">
            <path d="M8.82894 0.0236816V6.9485L8.82319 7.11711C8.75537 8.11573 8.09128 8.85224 7.35745 8.85224C6.58262 8.85224 5.88596 8.03219 5.88596 6.94811V0.0236816H8.82894ZM21.5819 0.0236816C22.6655 0.0236816 23.5438 0.901977 23.5438 1.98567V28.0015C23.5438 28.7821 23.0809 29.488 22.3651 29.7999C21.6493 30.1114 20.8174 29.9693 20.2456 29.4378L13.1081 22.7965C12.3552 22.0964 11.1891 22.0964 10.4361 22.7965L3.29821 29.4378C2.72647 29.9697 1.89416 30.1114 1.17834 29.7999C0.462523 29.488 0 28.7813 0 28.0008V1.98567C0 0.901977 0.878296 0.0236816 1.96199 0.0236816H3.92397V6.9485L3.92895 7.15044C4.02131 9.1634 5.48398 10.8146 7.35745 10.8146C9.29185 10.8146 10.7909 9.05189 10.7909 6.9485V0.0236816H21.5819Z" fill="#40526C"/>
            </g>
          </svg>
          <div v-if="item.tags&&item.tags.length>0" class="hoverCubeBlue">{{item.tags?.join(' ')}}</div>
        </td>
        <td :style="{textAlign: 'center'}">{{item.gender}}</td>
        <td :style="{textAlign: 'start', whiteSpace: 'nowrap'}">{{item.birth}}</td>
        <td :style="{textAlign: 'start'}">{{item.country}}</td>
        <td :style="{textAlign: 'start'}">{{item.consume ? formatDollarInt(item.consume.map(e => e.price).filter(e => e).reduce((a, b) => a + b, 0)) : '-'}}</td>
        <td :style="{textAlign: 'start'}" ><div class="toolong" :style="{maxWidth:'260px'}" >{{item.remark}}</div></td>
        <td :style="{textAlign: 'start'}">{{toDate(item.createTime)}}</td>
      </tr>
    </Table>
  </L1>

  <VipInfo :rolesmap="rolesmap" :itemSelect="itemSelect" @close="itemSelect=null" @updateItem="updateSelected"/>
  </div>
</template>

<script>
import L1 from '../../../components/layout/L1.vue'
import Select from '../../../components/select.vue'
import Table from '../../../components/tables/t2.vue'
// import infoSlider from '@components/infoSlider'
import { getapi } from '../../../store/fetch'
import VipInfo from './VIPinfo.vue'
import Page50 from '../../../components/input/page.vue'
import { mapState } from 'vuex'
const VUE_APP_BASE_URL = process.env.VUE_APP_BASE_URL
export default {
  name: 'VIPInformation',
  components: {
    Table,
    VipInfo,
    Select,
    // infoSlider,
    L1,
    Page50
  },
  computed: {
    max () {
      return Math.ceil(this.count / this.limit)
    },
    ...mapState({
      vipName: 'vipName',
      vipImg: 'vipImg'
    }),
    params () {
      let ageS = null
      let ageE = null
      switch (this.age) {
        case 8:
          ageS = 0
          ageE = 12
          break
        case 1:
          ageS = 13
          ageE = 18
          break
        case 2:
          ageS = 19
          ageE = 24
          break
        case 3:
          ageS = 25
          ageE = 34
          break
        case 4:
          ageS = 35
          ageE = 44
          break
        case 5:
          ageS = 45
          ageE = 54
          break
        case 6:
          ageS = 55
          ageE = 64
          break
        case 7:
          ageS = 65
          ageE = null
          break
        default:
          ageS = null
          ageE = null
          break
      }
      // const verified = this.$route.query.verified
      const params = {
        limit: this.limit,
        page: this.page
      }
      if (this.tag) params.tag = this.tag
      if (this.mobileVerified !== null) params.mobileVerified = this.mobileVerified
      if (ageS) params.ageS = ageS
      if (ageE) params.ageE = ageE
      if (this.country) params.country = this.country
      if (this.gender) params.gender = this.gender
      if (this.level) params.level = this.level
      if (this.searchText) params.search = this.searchText
      if (this.blank !== null) params.blank = this.blank
      if (this.role) params.role = this.role
      return new URLSearchParams(params)
    }
  },
  async created () {
    this.getusers()
    this.getrolemap()
    this.getcounties()
    const tags = await getapi('users/tagslist')
    this.tags = tags || []
  },
  data () {
    return {
      VUE_APP_BASE_URL,
      tags: [],
      addTeam: false,
      tag: null,
      count: 0,
      users: [],
      rolesmap: [],
      countries: [],
      itemSelect: null,
      searchText: null,
      role: null,
      blank: null,
      level: null,
      age: null,
      country: null,
      gender: null,
      mobileVerified: null,
      page: 1,
      limit: 15,
      fields: [
        '類型',
        '來自',
        '',
        '顯示名稱',
        '使用者暱稱',
        '性別',
        '生日',
        '居住縣市',
        '近半年消費',
        '註記',
        '註冊時間'
      ]
    }
  },
  watch: {
    page () { this.getusers() },
    tag () { this.getusers() },
    role () {
      this.getusers()
      this.page = 1
    },
    gender () {
      this.getusers()
      this.page = 1
    },
    level () {
      this.getusers()
      this.page = 1
    },
    age () {
      this.getusers()
      this.page = 1
    },
    mobileVerified () {
      this.getusers()
      this.page = 1
    },
    country () {
      this.getusers()
      this.page = 1
    },
    searchText () {
      this.getusers()
      this.page = 1
    },
    blank () {
      this.getusers()
      this.page = 1
    }
  },
  methods: {
    async getcounties () {
      this.countries = await getapi('selections/country')
    },
    async getrolemap () {
      const rolesmap = await getapi('selections/roles')
      console.log('rolesmap', rolesmap)
      this.rolesmap = Object.assign({}, ...rolesmap.filter(e => e.type === 'outter').map(e => { return { [e.key]: e.zh } }))
    },
    async getusers () {
      const users = await getapi(`users/all?${this.params}`)
      this.users = users.data
      this.count = users.count
      const tags = await getapi('users/tagslist')
      this.tags = tags || []
    },
    updateSelected (data) {
      const index = this.users.map(e => e._id).indexOf(data._id)
      // console.log(index, data)
      this.users.splice(index, 1, data)
      this.itemSelect = data
    }
  }
}
</script>

<style lang="scss" scoped>
.roundbtn {
  background-color: var(--color-checked);
  height: 50px;
  width: 120px;
  color: #FFFFFF;
  font-size: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  border-radius: 25px;
  gap: 10px;
  &>div {
    width: 26px;
    height: 26px;
    background-color: #FFFFFF;
    mask-image: url(/svg/btn/excel1.svg);
  }
}
.totalCount {
  font-size: 20px;
  font-weight: 700;
  letter-spacing: .1em;
  color: var(--color-pri);
}
.VIPInformation {
  min-width: calc(1920px - 70px);
}
th {
  white-space: nowrap;
}
div.vip, div.vvip, div.supervip {
  width: 30px;
  height: 30px;
  min-width: 30px;
  padding: 0;
  background-repeat: no-repeat;
  background-position: bottom;
  background-size: contain;
  appearance: none;
}
span.vip {
  display: inline-flex;
  width: 1em;
  height: 1em;
  background-repeat: no-repeat;
  background-position: bottom;
  background-size: contain;
  appearance: none;
  mask-image: none;
  &.vip1 {
    background-image: url(/vip.svg);
  }
  &.vip2 {
    background-image: url(/vvip.svg);
  }
  &.vip3 {
    background-image: url(/supervip.svg);
  }
}
div.vip {
  background-image: url(/vip.svg);
  mask-image: none;
}
div.supervip {
  background-image: url(/supervip.svg);
  mask-image: none;
}
div.vvip {
  background-image: url(/vvip.svg);
  mask-image: none;
}

.flex {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  z-index: 1;
  position: relative;
}
.hoverCube, .hoverCubeBlue {
  display: none;
  width: 345px;
  min-height: 55px;
  height: fit-content;
  position: absolute;
  top: 52px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.25);
  z-index: 2;
  left: 70px;
  padding: 14px 28px;
  border-radius: 5px;
  font-weight: 400;
  font-size: 18px;
  line-height: 26px;
  letter-spacing: 0.1em;
}
.hoverCube {
  background-color:#FFE8E8;
  color: #FF7373;
}
.hoverCubeBlue {
  background-color:#82ABD0;
  color: #FFFFFF;
}
td.hover:hover>.hoverCube,
td.hover:hover>.hoverCubeBlue {
  display: flex;
  text-align: start;
}
td, th {
  position: relative;
  padding-inline: 15px;
  // box-sizing: border-box;
  text-align: start;
  // border-right: 1px solid;
  &:nth-child(1) {
    width: 110px;
    text-align: center;
  }
  &:nth-child(2) {
    width: 80px;
    text-align: center;
  }
  &:nth-child(3) {
    width: 60px;
    padding: 0;
    .blank {
      display: flex;
      align-items: center;
      justify-content: center;
      color: #FFFFFF;
      margin-left: auto;
    }
  }
  &:nth-child(4) {
    width: 240px;
  }
  &:nth-child(6) {
    width: 60px;
    text-align: center;
  }
  &:nth-child(7) {
    width: 80px;
  }
  &:nth-child(8) {
    width: 80px;
    text-align: center;
  }
  &:nth-child(9) {
    width: 120px;
    text-align: end;
  }
  &:nth-child(11) {
    width: 140px;
  }
}
th {
  font-family: Roboto;
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
  letter-spacing: 0.1em;
  color: #000000;
}
td {
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 20px;
  letter-spacing: 0.1em;
  color: var(--color-letter);
}
.pageNum {
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 24px;
  line-height: 28px;

  color: var(--color-letter);

}
.addTeam, .importData {
  width: 150px;
  height: 50px;
  background: transparent;
  border-radius: 50px;
  font-family: Roboto;
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  letter-spacing: 0.1em;
  color: var(--color-checked);
  border:none;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  margin: 0;
  gap: 10px;
  &:disabled {
    filter: contrast(.5)
  }
}
.search {
  width: 260px;
  height: 40px;
  box-sizing: border-box;
  background-image: url(/search.svg);
  background-position: calc(100% - 10px) 10px;
  background-repeat: no-repeat;
  border-radius: 3px;
  border: 1px solid #C4C4C4;
  text-indent: 12px;
  font-size: 18px;
  display: flex;
  align-items: center;
  &::placeholder {
    color: var(--color-border);
  }
}
select {
  box-sizing: border-box;
  width: 175px;
  height: 40px;
  border: 1px solid #C4C4C4;
  border-radius: 3px;
  text-indent: 12px;
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 21px;
  letter-spacing: 0.1em;
  color: var(--color-checked);
}
input[type=radio] {
  width: 125px;
  height: 40px;
  background-color: var(--color-border);
  appearance: none;
  border-radius: 3px;
  display: flex;
  align-items: center;
  justify-content: center;
  &::before {
    content: attr(value);
    font-family: Roboto;
    font-style: normal;
    font-weight: 900;
    font-size: 18px;
    line-height: 21px;
    letter-spacing: 0.1em;
    color: #FFFFFF;
  }
  &:checked {
    background-color: var(--color-checked);
  }
  &:hover {
    filter: contrast(.5);
  }
}
.VIPInformation {
table {
  min-height: 300px;

}
.header {
  height: 89px;
  display: flex;
  align-items: center;
  font-family: Noto Sans TC;
  font-style: normal;
  font-weight: normal;
  font-size: 36px;
  line-height: 52px;
  letter-spacing: 0.15em;
  border-bottom: 1px solid var(--color-border);
  color: var(--color-pri);
  gap: 20px;
  span {
    display: inline-flex;
    align-items: center;
    gap: 10px;
  }
}
}
.box {
  width: 422px;
  height: 505px;
  min-height: 505px;
  border: 1px solid var(--color-pri);
  border-radius: 10px;
  box-sizing: border-box;
}
</style>
